import { Component, Input, OnInit } from '@angular/core';
import { Familiares } from 'src/app/core/familiares';
import { SituacaoParentesco } from 'src/app/core/situacao-parentesco';
import { GrausParentesco } from '../../../core/graus-parentesco';
import { DataUtilService } from '../../../services/commons/data-util.service';
import { GrausParentescoService } from '../../../services/graus-parentesco/graus-parentesco.service';

@Component({
  selector: 'parentesco',
  templateUrl: './parentesco.component.html',
  styleUrls: ['./parentesco.component.css']
})
export class ParentescoComponent implements OnInit {

  @Input() familiar: Familiares;

  situacaoParentesco: SituacaoParentesco = new SituacaoParentesco();
  grausParentesco: GrausParentesco[];

  constructor( private grausParentescoService: GrausParentescoService, private dataUtilService: DataUtilService) { }

  ngOnInit() {
    this.grausParentescoService.getAll().subscribe((graus: GrausParentesco[]) => this.grausParentesco = graus);
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

}